import React, { useState } from 'react';
import AuroraBackground from '../components/AuroraBackground';
import device1 from '../assets/p5.gif';
import device2 from '../assets/red-tasman-devil.gif';
import device3 from '../assets/wombat.gif';
import device4 from '../assets/winding.png';
import device5 from '../assets/school-zone.gif';

const products = [
  { name: 'RGB P5 LED Series', image: device1 },
  { name: 'RGB P10 LED Series', image: device2 },
  { name: 'RG P10 LED Series', image: device3 },
  { name: 'Warning Sign Series', image: device4 },
  { name: 'School Zone Series', image: device5 },
];

const categories = [
  {
    name: 'General',
    specs: [
      {
        label: 'Application',
        values: [
          'High-resolution full-color displays for ultra-clear detailed messaging and animated content.',
          'Balanced performance displays suitable for all environments: roads, mine sites, & public spaces.',
          'Dual-color red/green displays with exceptional long-distance visibility for remote locations.',
          'winding road, turn alerts, stop ahead - all standard road safety configurations.',
          'Enhanced school zone signs with scheduled operation for student safety.',
        ],
      },
    ],
  },
  {
    name: 'Physical Specification',
    specs: [
      { label: 'Dimensions', values: ['1000mm (H) x 800mm (W) x 150mm (T)', '1000mm (H) x 800mm (W) x 150mm (T)', '1000mm (H) x 800mm (W) x 150mm (T)', '750mm x 750mm x 150mm (T) + 400mm (H) x 750mm (W) x 150mm (T)', '2400mm (H) x 800mm (W) x 150mm (T)'] },  
      { label: 'Enclosure Material', values: ['Powder-Coated Aluminum', 'Powder-Coated Aluminum', 'Powder-Coated Aluminum'] },
    ],
  },
  {
    name: 'Display Specification',
    specs: [
      { label: 'Display Resolution', values: ['128 x 96', '64 x 48', '64 x 48', 'N/A', 'N/A'] },
      { label: 'Display Size', values: ['640 x 480 mm', '640 x 480 mm', '640 x 480 mm', 'N/A', 'N/A'] },
      { label: 'Color Capacity', values: ['Full Color', 'Full Color', 'Bi-Color (Red/Green)', 'White/Yellow', 'Red/Yellow'] },
      { label: 'Pixal Pitch', values: ['5 mm', '10mm', '10mm', 'N/A', 'N/A'] },
      { label: 'Brightness', values: ['8,000 cd/m²', '8,000 cd/m²', '10,000 cd/m²', '15,000 cd/m² (apparent brightness)', '10,000 cd/m²' ] },
      { label: 'Viewing Angle', values: ['160° H/V', '160° H/V', '120°(H) / 60°(V)', '60°', '90°'] },
    ],
  },
  {
    name: 'Radar Sensor',
    specs: [
      { label: 'Detection Range', values: ['> 100 m', '> 100 m', '> 100 m', '> 100 m', '> 100 m (Optional)'] },
      { label: 'Speed Range', values: ['1 ~ 220 km/h', '1 ~ 220 km/h', '1 ~ 220 km/h', '1 ~ 220 km/h', '1 ~ 220 km/h (Optional)'] },
      { label: 'Accuracy', values: ['± 1 km/h', '± 1 km/h', '± 1 km/h', '± 1 km/h', '± 1 km/h (Optional)'] },
      { label: 'Mounting Angle Adjustment', values: ['± 15°', '± 15°', '± 15°', '± 15°', '± 15° (Optional)'] },
      { label: 'Detecting Angle', values: ['± 48°', '± 48°', '± 48°', '± 48°', '± 48° (Optional)'] },
      { label: 'Lane Coverage', values: ['1 ~ 4 lanes', '1 ~ 4 lanes', '1 ~ 2 lanes', '1 ~ 2 lanes', '1 ~ 2 lanes (Optional)'] },
    ],
  },
  {
    name: 'Power System',
    specs: [
      { label: 'Power Source', values: ['Li-ion Battery', 'Li-ion Battery', 'Li-ion Battery'] },
      { label: 'Battery Capacity', values: ['12V120A', '12V60A', '12V60A', '12V60A', '12V60A'] },
      { label: 'Battery Cycle Life', values: ['> 2000 Cycles', '> 2000 Cycles', '> 2000 Cycles', '> 2000 Cycles', '> 2000 Cycles'] },
      { label: 'Solar Panel Wattage', values: ['200 W', '100 W', '100 W', '100 W', '100 W'] },
      { label: 'Autonomous Runtime *', values: ['~ 100 Hours', '~ 75 Hours', '~ 90 Hours', '~ 100 Hours', '~ 80 Hours'] },
    ],
  },
  {
    name: 'Connectivity & Control',
    specs: [
      { label: 'Connectivity', values: ['GSM, GPRS, EDGE, WCDMA, WCDMA, HSPA, LTE, Wi-Fi, Bluetooth, Ethernet', 'GSM, GPRS, EDGE, WCDMA, WCDMA, HSPA, LTE, Wi-Fi, Bluetooth, Ethernet', 'GSM, GPRS, EDGE, WCDMA, WCDMA, HSPA, LTE, Wi-Fi, Bluetooth, Ethernet'] },
      { label: 'Control Interface', values: ['Web-Based Portal', 'Web-Based Portal', 'Web-Based Portal'] },
      { label: 'Remote Configuration', values: ['Yes', 'Yes', 'Yes'] },
      { label: 'Firmware Updates', values: ['Manual & OTA', 'Manual & OTA', 'Manual & OTA'] },
    ],
  },
  {
    name: 'Security Features',
    specs: [
      { label: 'Anti-Tamper Features', values: ['GPS Tracking, Tilt Sensor, Door Sensor, Thermometer, Padlock Support', 'GPS Tracking, Tilt Sensor, Door Sensor, Thermometer, Padlock Support', 'GPS Tracking, Tilt Sensor, Door Sensor, Thermometer, Padlock Support'] },
      { label: 'Battery BMS Protections', values: ['Cell Over Voltage, Cell Under Voltage, Pack Over Voltage, Pack Under Voltage, Charging Over Temperature, Discharging Over Temperature, Discharging Under Temperature, Charging Over Current, Discharging Over Current, Short Circuit, BMS Error, MOS Lock', 'Cell Over Voltage, Cell Under Voltage, Pack Over Voltage, Pack Under Voltage, Charging Over Temperature, Discharging Over Temperature, Discharging Under Temperature, Charging Over Current, Discharging Over Current, Short Circuit, BMS Error, MOS Lock', 'Cell Over Voltage, Cell Under Voltage, Pack Over Voltage, Pack Under Voltage, Charging Over Temperature, Discharging Over Temperature, Discharging Under Temperature, Charging Over Current, Discharging Over Current, Short Circuit, BMS Error, MOS Lock'] },
    ],
  },
  {
    name: 'Compliance & Security Features',
    specs: [
      { label: 'Australian Manufactured', values: ['Yes', 'Yes', 'Yes'] },
      { label: 'Secure Local Hosting', values: ['Australia', 'Australia', 'Australia'] },
      { label: 'Data Encryption', values: ['Yes', 'Yes', 'Yes'] },
    ],
  },
  {
    name: 'Optional Add-ons',
    specs: [
      { label: 'Portal Base', values: ['Optional', 'Optional', 'Optional'] },
      { label: 'Custom Branding', values: ['Optional', 'Optional', 'Optional'] },
      { label: 'Extended Battery Capacity', values: ['Standard', 'Optional', 'Optional', 'Optional', 'Optional'] },
      { label: 'Wig-Wag Warning Lights', values: ['Optional', 'Optional', 'Optional', 'Optional', 'Standard'] },
    ],
  },
];

// 4-column grid: spec label + 3 product columns.
const ROW = 'grid grid-cols-[1.5fr_1fr_1fr_1fr_1fr_1fr]';

// A spec is "uniform" when every product shares the same value.
const isUniform = (spec) => spec.values.every((v) => v === spec.values[0]);

// Within a section, surface the uniform (merged) specs at the top in alphabetical
// order; keep the differing specs below in their original order.
const orderSpecs = (specs) => {
  const uniform = specs.filter(isUniform).sort((a, b) => a.label.localeCompare(b.label));
  const varied = specs.filter((s) => !isUniform(s));
  return [...uniform, ...varied];
};

const Products = () => {
  const [hovered, setHovered] = useState(null);
  const colTint = (i) => (hovered === i ? 'bg-slate-50' : '');

  return (
    <div className="relative min-h-screen overflow-hidden bg-white">
      <AuroraBackground />

      <div className="relative z-10 mx-auto max-w-[1200px] px-6 py-24 md:py-28">
        {/* Header */}
        <header className="mb-14 max-w-[780px]">
         
          <h1 className="text-[2.5rem] font-extrabold leading-[1.05] tracking-[-1.5px] text-[#0f172a] md:text-[3.25rem]">
            Product Specifications
          </h1>
        </header>

        {/* Comparison table */}
        <div className="overflow-x-auto rounded-2xl border border-slate-200 bg-white/80 shadow-[0_8px_30px_rgba(15,23,42,0.05)] backdrop-blur-sm">
          <div className="min-w-[820px]">
            {/* Header row */}
            <div className={`${ROW} border-b-2 border-slate-300 bg-slate-50`}>
  <div className="p-6 text-sm font-semibold text-slate-900 sticky left-0 bg-slate-50 z-10">Models</div>
  {products.map((product, i) => (
    <div
      key={i}
      onMouseEnter={() => setHovered(i)}
      onMouseLeave={() => setHovered(null)}
      className={`border-l border-slate-200 p-4 transition-colors ${colTint(i)}`}
    >
      <img 
        src={product.image} 
        alt={product.name}
        className="w-full h-28 object-contain mb-3 rounded-xl shadow-sm bg-slate-50"
      />
      <div className="text-sm font-bold bg-[linear-gradient(135deg,#ff3b30,#30d158,#0a84ff)] bg-clip-text text-transparent text-center">
        {product.name}
      </div>
    </div>
  ))}
</div>

            {/* Categories */}
            {categories.map((category, catIndex) => (
              <div key={catIndex}>
                <div className="border-b border-slate-200 bg-slate-100/70 px-4 py-2.5 text-xs font-semibold uppercase tracking-[0.15em] text-slate-500">
                  {category.name}
                </div>
                {orderSpecs(category.specs).map((spec, specIndex) => {
                  // If every product shares the same value, merge into one cell that
                  // spans all the product columns instead of repeating it.
                  const allSame = isUniform(spec);
                  return (
                    <div
                      key={specIndex}
                      className={`${ROW} border-b border-slate-100 transition-colors last:border-b-0 hover:bg-slate-50/80`}
                    >
                      <div className="p-4 text-sm font-medium text-[#0f172a]">{spec.label}</div>
                      {allSame ? (
                        <div className="col-span-5 border-l border-slate-100 p-4 text-center text-sm leading-relaxed text-slate-600">
                          {spec.values[0]}
                        </div>
                      ) : (
                        spec.values.map((value, i) => (
                          <div
                            key={i}
                            onMouseEnter={() => setHovered(i)}
                            onMouseLeave={() => setHovered(null)}
                            className={`border-l border-slate-100 p-4 text-sm leading-relaxed text-slate-600 transition-colors ${colTint(i)}`}
                          >
                            {value}
                          </div>
                        ))
                      )}
                    </div>
                  );
                })}
              </div>
            ))}

            {/* Footnote */}
            <div className="border-t border-slate-200 bg-slate-50/70 p-4">
              <p className="text-xs italic leading-relaxed text-slate-400">
                * Autonomous runtime estimates are based on typical usage patterns. Actual runtime may
                vary depending on environmental factors and usage intensity.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Products;
